export default __webpack_public_path__ + "static/media/invocom-question-icon.33383d4b.svg";